// extracted by mini-css-extract-plugin
export var backdropBlur = "_ft-0";
export var contentCard = "_ft-5";
export var frame = "_ft-2";
export var image = "_ft-4";
export var imagePane = "_ft-3";
export var modal = "_ft-1";